<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" xl="12">
        <b-card :header="$t('Player')" style="position:relative">
          <b-form @submit.prevent="onSubmitDetails" autocomplete="off" ref="cnt">
            <b-form-group :label="$t('Name')">
              <b-form-input v-model="details.name" type="text"></b-form-input>
            </b-form-group>

            <b-form-group :label="$t('Description')">
              <b-form-input v-model="details.description" type="text"></b-form-input>
            </b-form-group>

            <b-form-group>
              <template slot="label">
                {{$t('Rules')}}
                <b-button @click="addSet" class="ml-2 btn-brand btn-bold" size="sm">
                  <i class="icon-plus"/>
                  {{$t('Add set')}}
                </b-button>
              </template>
              <div
                v-for="(set, index) in details.ruleset"
                v-bind:key="set.id"
                style="position:relative"
                class="mb-3"
              >
                <vue-query-builder
                  :rules="rules"
                  :labels="labels"
                  v-model="details.ruleset[index]"
                  :maxDepth="3"
                ></vue-query-builder>
                <b-badge variant="info" class="bdg">#{{ index + 1 }}</b-badge>
                <b-badge
                  variant="danger"
                  class="bdg-close"
                  @click="removeSet(index)"
                  :title="$t('Delete set')"
                >&times;</b-badge>
              </div>
            </b-form-group>

            <div style="text-align:right">
              <b-button type="submit" variant="success">{{$t('Save')}}</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { successConf, errorConf } from "@/shared/notifications";
import VueQueryBuilder from "@/components/query-builder/VueQueryBuilder";
import VueClockPicker from "@/components/clock-picker";

function makeid(length) {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export default {
  name: "firewall",
  props: ["selectedeid"],
  components: {
    VueQueryBuilder
  },
  mounted() {
    this.eid = this.$route.params.id != "0" ? this.$route.params.id : "";

    if (this.selectedeid) {
      this.eid = this.selectedeid;
    } else if (!this.eid) {
      this.eid = "";
    }

    if (this.eid != "0" && this.eid != "") {
      this.loadData();
    } else {
      this.newId = true;
    }

    this.buildChoices();
  },
  data: function() {
    return {
      eid: "",
      details: {
        name: "",
        description: "",
        ruleset: []
      },
      labels: {
        matchTypes: [{ id: "and", label: "and" }, { id: "or", label: "or" }],
        addRule: "Rule",
        removeRule: "&times;",
        addGroup: "Group",
        removeGroup: "&times;",
        textInputPlaceholder: "value",
        addThen: "Then",
        valueInputPlaceholder: "return value",
        messageInputPlaceholder: "with message",
        ifTrue: "If TRUE",
        removeThen: "&times;"
      },
      choices: [
        "BlockValue",
        "TotalStake",
        "TotalStakeShop",
        "MaxWinning",
        "MaxWinningShop",
        "NumberOfIdenticalTickets"
      ],
      rules: [
        {
          type: "select",
          id: "LiabilityExceeded",
          label: "LiabilityExceeded",
          choices: [
            { label: "True", value: "true" },
            { label: "False", value: "false" }
          ]
        },
        {
          type: "suggest",
          id: "BlockValue",
          label: "BlockValue",
          choices: []
        },
        {
          type: "suggest",
          id: "TotalStake",
          label: "TotalStake",
          choices: []
        },
        {
          type: "suggest",
          id: "TotalStakeShop",
          label: "TotalStakeShop",
          choices: []
        },
        {
          type: "suggest",
          id: "maxWinning",
          label: "MaxWinning",
          choices: []
        },
        {
          type: "suggest",
          id: "MaxWinningShop",
          label: "MaxWinningShop",
          choices: []
        },
        {
          type: "suggest",
          id: "NumberOfIdenticalTickets",
          label: "NumberOfIdenticalTickets",
          choices: []
        },
        {
          type: "custom-component",
          id: "RegistrationTime",
          label: "RegistrationTime",
          component: VueClockPicker,
          default: "00:00",
          operators: ["==", "<>", "<", "<=", ">", ">="]
        },
        {
          type: "numeric",
          id: "IsTerminal",
          label: "IsTerminal"
        }
      ],
      newId: false
    };
  },
  methods: {
    buildChoices() {
      this.rules.forEach(element => {
        if (element.type == "suggest") {
          element.choices = this.filterChoices(element.id);
        }
      });
    },
    filterChoices(skip) {
      const copy = JSON.parse(JSON.stringify(this.choices));
      const tmp = [];
      copy.forEach(element => {
        if (element != skip) {
          tmp.push(element);
        }
      });
      return tmp;
    },
    addSet() {
      this.details.ruleset.push({ id: makeid(32) });
    },
    removeSet(index) {
      /*const copy = JSON.parse(JSON.stringify(this.details.ruleset));
      copy.splice(index, 1);
      this.details.ruleset = copy;*/
      this.$delete(this.details.ruleset, index);
    },
    loadData() {
      if (this.eid == "") return;

      const loader = this.$loading.open({
        container: this.$refs.cnt
      });

      this.$store
        .dispatch("firewall/read", this.eid)
        .then(resp => {
          this.populateData(resp.data);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },
    onSubmitDetails() {
      const loader = this.$loading.open({
        container: this.$refs.cnt
      });

      const detailsData = JSON.parse(JSON.stringify(this.details));
      let apiAction = "firewall/update";
      if (this.newId) {
        apiAction = "firewall/create";
      } else {
        detailsData.eid = this.eid;
      }

      detailsData.ruleset = JSON.stringify(detailsData.ruleset);

      this.$store
        .dispatch(apiAction, detailsData)
        .then(resp => {
          let msg = "Ruleset updated";
          if (this.newId && resp.data.id) {
            this.updateId(resp.data.id);
            msg = "Ruleset created";
          }
          this.showSuccessNotification(msg);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },
    populateData(r) {
      if (typeof r == "undefined") return;
      this.eid = typeof r.eid != "undefined" ? r.eid : "";

      this.details.name = r.name;
      this.details.description = r.description;
      try {
        this.details.ruleset = r.ruleset ? JSON.parse(r.ruleset) : [];
      } catch (err) {
        this.details.ruleset = [];
      }
    },
    updateId(id) {
      this.eid = id;
      this.newId = false;
      this.$router.replace({ name: "Firewall Ruleset", params: { id: id } });
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    }
  }
};
</script>

<style lang="scss" scoped>
.bdg {
  position: absolute;
  top: 10px;
  left: -14px;
  margin-top: -16px;
  margin-left: 0;
}
.bdg-close {
  position: absolute;
  top: 10px;
  left: calc(100% - 10px);
  margin-top: -16px;
  margin-left: 0;
  cursor: pointer;
}
</style>
